import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { Box } from '@material-ui/core'

import { getUserType } from 'components/SegmentSelector/UserTypeSelector'
import getModalConfig from '../get-modal-config'
import TriggerSelector from './TriggerSelector'
import StudentSegmentation from './StudentSegmentation'
import ParentSegmentation from './ParentSegmentation'
import AudienceTypeSelector from './AudienceTypeSelector'
import { isParent, USER_TYPE, DEFAULT_USER_TYPE } from 'components/SegmentSelector/UserTypeSelector'

export const Audience = ({ trigger, segment, onError, onUpdate }) => {
  const { enableTriggerSelector } = getModalConfig(trigger)
  const userType = getUserType(segment)
  const updateSegment = useCallback(
    (segment) => {
      onUpdate('Segment', segment)
    },
    [onUpdate],
  )
  return (
    <Box pt={3}>
      {enableTriggerSelector && (
        <TriggerSelector
          isParent={isParent(segment)}
          trigger={trigger}
          onChange={(trigger) => onUpdate('Trigger', trigger)}
        />
      )}
      <AudienceTypeSelector
        trigger={trigger}
        segment={segment}
        onChange={updateSegment}
      >
        {userType === USER_TYPE.parents && (
          <ParentSegmentation
            trigger={trigger}
            segment={segment}
            onChange={updateSegment}
            onError={onError}
          />
        )}
        {userType === USER_TYPE.students && (
          <StudentSegmentation
            trigger={trigger}
            segment={segment}
            onChange={updateSegment}
            onError={onError}
          />
        )}
      </AudienceTypeSelector>
    </Box>
  )
}

Audience.propTypes = {
  trigger: PropTypes.string,
  segment: PropTypes.object,
  isEditing: PropTypes.bool,
  onError: PropTypes.func,
  onUpdate: PropTypes.func.isRequired,
}

Audience.defaultProps = {
  trigger: DEFAULT_USER_TYPE,
}

export default Audience
